import { z } from 'zod';
import { sumBy, round } from 'lodash';
import { isMongoId } from './';
import { AllocationRule } from 'further-types/lp/allocations';

export default z.array(
  z.object({
    _id: z.string().optional(),
    commitmentId: z.string().refine(isMongoId()),
    equalisationId: z.string().refine(isMongoId()),
    investorLabel: z.string().trim(),
    allocationAmountTcy: z.number(),
    allocationPercentage: z.number(),
    excludeFromAllocation: z.boolean(),
    allocationRule: z.nativeEnum(AllocationRule),
  }),
);

export const allocationMatchesCheckAmount = (
  checkAmount: number,
  allocations: Array<{ allocationAmountTcy: number }>,
) => {
  const totalAllocationAmountTcy = sumBy(
    allocations,
    (item) => item.allocationAmountTcy,
  );

  return round(totalAllocationAmountTcy, 2) === checkAmount;
};
